module.exports = __webpack_public_path__ + "img/zl1.3ebf49a6.png";